<app-header></app-header>

<div class="container main-container"
     [ngStyle]="{ 'background-image': catalogueService.getProperty('imageBackground') ? 'url(' + catalogueService.getProperty('imageBackground') + ')' : 'none' }">

  <app-edition-panel *ngIf="loginService.isAuth()" [catalogueId]="eventData['id']" [hidesEditItem]="true"></app-edition-panel>

  <app-menu-tabs [filter]="'ONLY_EXHIBITORS'"></app-menu-tabs>

  <div class="container-fluid counter">
    {{ numElements }} {{ 'exhibitors' | customTranslation:'MENU_TABS.EXHIBITORS':translateService.currentLang | translate | lowercase }}
  </div>
  
  <div class="container-fluid">
    <card-grid *ngIf="selectedView === 'grid' && show" [page]="page" [items]="items" [show]="show" [banner]="getBannerByType('grid')"></card-grid>
    <card-modern *ngIf="selectedView === 'modern' && show" [page]="page" [items]="items" [show]="show" [banner]="getBannerByType('modern')"></card-modern>
    <card-list *ngIf="selectedView === 'list' && show" [page]="page" [items]="items" [show]="show" [banner]="getBannerByType('list')"></card-list>
  </div>
    <loader-throbber *ngIf="loader.count > 0"></loader-throbber>
  <div *ngIf="showAddMore()">
    <button class="see_more_button" [style.color]="catalogueService.getProperty('languageColor')" [style.backgroundColor]="mainColor" (click)="pages()">{{ 'COMMON.SHOW_MORE' | translate }}</button>
  </div>

  
  <app-no-results *ngIf="items.length === 0 && loader.count === 0"></app-no-results>

</div>
<!--   <app-card-detail></app-card-detail>  app-my-favorites
 -->
<app-footer></app-footer>
